//import React from 'react';
import React, { Component } from 'react';


//CSS Import
// import '../../css/QuestionWithImage.css'

import { Card, CardContent, Grid, IconButton, Tooltip, Typography } from '@mui/material';
import MathJax from '../../../../components/react-mathjax-preview';
import AnswerTypeRPTextBox from '../../../../ui/takeQuiz/AnswerTypeRPTextBox';
import MathParserUtil from '../../../../lib/math-parser';
import { MQTOptions } from '../../../../lib/mqt';
import { VectorQuestion, VectorAnswers } from '../../../../ui/takeQuiz/vectors';
import { createVideoLinkIframe } from '../../../../common/functions';
import MQTQuestion from '../../../../ui/takeQuiz/mqt/MQTQuestion';
import SFVectorTypeAnswer from './answers/SFVectorTypeAnswer';
import SFMCRadioTypeAnswers from './answers/SFMCRadioTypeAnswers';
import SFMCChecboxTypeAnswers from './answers/SFMCChecboxTypeAnswers';
import SFTextboxTypeAnswer from './answers/SFTextboxTypeAnswer';
import AnswerTypeReasoningChain from '../../../../ui/takeQuiz/AnswerTypeReasoningChain';
import { RxEnterFullScreen } from "react-icons/rx";
import { CgMinimize } from "react-icons/cg";
import { FaMinus } from "react-icons/fa6";
import { HiOutlineZoomIn, HiOutlineZoomOut } from "react-icons/hi";
import SFCompactQA from './SFCompactQA';
import SFExcludeAOCheckboxAnswers from './answers/SFExcludeAOCheckboxAnswers';
import { AutomationType } from '../../../../common/constants';

const getCleanQuestionText = (htmlText) => {
    if (!htmlText) return '';
    // Replace HTML tags with space
    let text = htmlText.replace(/<[^>]*>/g, ' ');
    // Clean up multiple spaces
    text = text.replace(/\s+/g, ' ').trim();
    return text;
};

//const QuestionWithImage = function(this.props) {
class SFQuestionAndAnswer extends Component {

    constructor(props) {
        super(props)
        this.questionCardRef = React.createRef();
        this.answerCardRef = React.createRef();
        this.state = {
            shouldRefreshRadioComp: true,
            variableMap: this.props.currentVariableMap,
            mqt_options: {},
            questionImageWidth: 500,
            answerImageWidth: 200,
        }
        this.answerContainsAnImage = false;

        this.onAnswerChoice = this.onAnswerChoice.bind(this);
        this.onAnswerTextbboxHandler = this.onAnswerTextbboxHandler.bind(this);
        this.answersDetailsDisplay = this.answersDetailsDisplay.bind(this);
        //this.onAnswerTextbboxHandler = this.onAnswerTextbboxHandler.bind(this);
        this.refreshShoeList = this.refreshShoeList.bind(this);


    }
    UNSAFE_componentWillMount() {
        console.log('this.props.currentQuestionType', this.props.currentQuestionType);

        if (this.props.currentQuestionType === 2) {

            this.setState({ mqt_options: MQTOptions.CreateMQTFromApi(this.props.mqt_options) });
        }
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        console.log('this.props.currentQuestionType', nextProps.currentQuestionType);

        if (nextProps.currentQuestionType === 2) {

            this.setState({ mqt_options: MQTOptions.CreateMQTFromApi(nextProps.mqt_options) });
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps && this.props) {
            if (prevProps?.count !== this.props?.count) {
                this.setState({
                    questionImageWidth: 500,
                    answerImageWidth: 200
                })
            }
        }
        this.loadImages()
    }

    onAnswerChoice(value, index) {
        // console.log("select Answer is ",value);
        // console.log("select Answer is ",index);

        this.props.onAnswerClick(value, index);


    }

    onMQTAnswerChoice = (value) => {
        this.props.onAnswerClick(value);
    }

    onAnswerTextbboxHandler(value) {


        //console.log("evt.target.value  ",evt.target.value);
        this.props.onAnswerEntered(value);

    }
    answersDetailsDisplay() {
        let answerDisplay = null;
        console.log('this.props.currentQuestionType', this.props.currentQuestionType, this.props.answerType);
        //Display MQT Question Type

        this.answerContainsAnImage = false;

        // EXCLUDE AO (Assessment Link + Exclude AO mapping)
        if (this.props.currentQuestionObj && this.props.currentQuestionObj.is_automation && this.props.currentQuestionObj.automation_type === AutomationType.EXCLUDE_AO_CONTEXT) {
            const excludedAoList = this.props.currentQuestionObj.excluded_ao_list;
            const subcatKeys = excludedAoList
                ? (typeof excludedAoList === 'string' ? JSON.parse(excludedAoList) : excludedAoList)
                : [];
            return <SFExcludeAOCheckboxAnswers
                selectedSubcategoryKeys={subcatKeys}
                onAnswerEntered={this.onAnswerTextbboxHandler}
                selectedAnswers={this.props.selectedAnswers}
            />;
        }

        if (this.props && this.props.displayAnswerArr && this.props.displayAnswerArr.length) {
            this.props.displayAnswerArr.forEach(answer => {
                if (answer && answer.answer_text && answer.answer_text.includes("<img")) {
                    this.answerContainsAnImage = true;
                }
            })
        }

        if (this.props && this.props.currentQuestionType === 0 && [70].includes(this.props.answerType)) {
            answerDisplay = <SFMCRadioTypeAnswers
            displayAnswerArr={this.props.displayAnswerArr}
            onAnswerChoice={this.onAnswerChoice}
            selectedAnswers={this.props.selectedAnswers}
            numOfColumns={this.props.answerDisplayStyle}
            currentQuestionType={this.props.currentQuestionType}
            currentVariableMap={this.props.currentVariableMap}
            isMobile={this.props.isMobile}
            showAnswerResponse={this.props.showAnswerResponse}
            answerCorrect={this.props.answerCorrect}
            showSubmitLoader={this.props.showSubmitLoader}
            vectorSettingsData={this.props.currentVectorSettings}
            currentAnswerType={this.props.answerType}
        />
        }
        if (this.props && this.props.currentQuestionType === 0 && [80].includes(this.props.answerType)) {
            answerDisplay = <SFMCChecboxTypeAnswers
                displayAnswerArr={this.props.displayAnswerArr}
                selectedAnswerArray={this.props.selectedAnswers}
                onAnswerChoice={this.onAnswerChoice}
                numOfColumns={this.props.answerDisplayStyle}
                currentQuestionType={this.props.currentQuestionType}
                currentVariableMap={this.props.currentVariableMap}
                isMobile={this.props.isMobile}
                showAnswerResponse={this.props.showAnswerResponse}
                answerCorrect={this.props.answerCorrect}
                showSubmitLoader={this.props.showSubmitLoader}
                vectorSettingsData={this.props.currentVectorSettings}
                currentAnswerType={this.props.answerType}
                selectedAnswers={this.props.selectedAnswers}
            />
        }
        if (this.props && this.props.currentQuestionType === 0 && [90].includes(this.props.answerType)) {
            answerDisplay = <SFVectorTypeAnswer
            currentQuestionID={this.props.questionID}
            questionText={this.props.questionText}
            onAnswerChoice={this.onMQTAnswerChoice}
            answerType={this.props.answerType}
            variableMap={this.props.currentVectorVariable}
            answers={this.props.displayAnswerArr}
            selectedAnswer={this.props.selectedAnswers}
            vectorSettings={this.props.currentVectorSettings}
            showVectorAnswer={this.props.showVectorAnswer}
            correctAnswerVectors={this.props.correctAnswerVectors}
            vectorAnswerFormulas={this.props.vectorAnswerFormulas}
            freeFormVectorOptions={this.props.freeFormVectorOptions}
            numOfColumns={this.props.answerDisplayStyle}
            showAnswerResponse={this.props.showAnswerResponse}
            answerCorrect={this.props.answerCorrect}
            count={this.props.count}
            showSubmitLoader={this.props.showSubmitLoader}
            selectedAnswers={this.props.selectedAnswers}
            alreadyPickedAnswer={this.props.alreadyPickedAnswer}
            question_attempt={this.props.question_attempt}
        />
        }


        if (this.props && this.props.currentQuestionType === 4) {
            if (this.props.reasoningElements && this.props.reasoningElements.length) {
                this.props.reasoningElements.forEach(ele => {
                    if (ele && ele.element && ele.element.includes("<img")) {
                        this.answerContainsAnImage = true
                    }
                })
                this.props.conclusionSentences.forEach(ele => {
                    if (ele && ele.sentence && ele.sentence.includes("<img")) {
                        this.answerContainsAnImage = true
                    }
                })
            }
        }

        if (this.props.currentQuestionType === 2) {
            answerDisplay = <MQTQuestion
                mqt_options={this.state.mqt_options}
                onAnswerChoice={this.onMQTAnswerChoice}
                questionID={this.props.questionID}
                showMQTAnswers={this.props.showMQTAnswers}
                isMobile={this.props.isMobile}
                showAnswerResponse={this.props.showAnswerResponse}
                answerCorrect={this.props.answerCorrect}
                showSubmitLoader={this.props.showSubmitLoader}
                count={this.props.count}
                compact={this.props.compact}
                selectedAnswers={this.props.selectedAnswers}
                question_attempt={this.props.question_attempt}
                alreadyPickedAnswer={this.props.alreadyPickedAnswer}
            />
        } else if (this.props.currentQuestionType === 3) {
            console.debug("this.props.currentVectorVariable>>>", this.props.currentVectorVariable, this.props.currentVariableMap)
            /*  answerDisplay = <VectorAnswers
                 currentQuestionID={this.props.questionID}
                 questionText={this.props.questionText}
                 onAnswerChoice={this.onMQTAnswerChoice}
                 answerType={this.props.answerType}
                 variableMap={this.props.currentVectorVariable}
                 answers={this.props.displayAnswerArr}
                 selectedAnswer={this.props.selectedAnswers}
                 vectorSettings={this.props.currentVectorSettings}
                 showVectorAnswer={this.props.showVectorAnswer}
                 correctAnswerVectors={this.props.correctAnswerVectors}
                 vectorAnswerFormulas={this.props.vectorAnswerFormulas}
                 freeFormVectorOptions={this.props.freeFormVectorOptions}
             /> */
            if (this.props.answerType === 30 || this.props.answerType === 50) {
                answerDisplay = <SFMCRadioTypeAnswers
                    displayAnswerArr={this.props.displayAnswerArr}
                    onAnswerChoice={this.onAnswerChoice}
                    selectedAnswers={this.props.selectedAnswers}
                    numOfColumns={this.props.answerDisplayStyle}
                    currentQuestionType={this.props.currentQuestionType}
                    currentVariableMap={this.props.currentVariableMap}
                    isMobile={this.props.isMobile}
                    showAnswerResponse={this.props.showAnswerResponse}
                    answerCorrect={this.props.answerCorrect}
                    currentVectorVariableMap={this.props.currentVectorVariable}
                    answerType={this.props.answerType}
                    showSubmitLoader={this.props.showSubmitLoader}
                    currentAnswerType={this.props.answerType}
                    compact={this.props.compact}
                />

            } else if (this.props.answerType === 40 || this.props.answerType === 60) {
                answerDisplay = <SFMCChecboxTypeAnswers
                    displayAnswerArr={this.props.displayAnswerArr}
                    onAnswerChoice={this.onAnswerChoice}
                    selectedAnswerArray={this.props.selectedAnswers}
                    numOfColumns={this.props.answerDisplayStyle}
                    currentQuestionType={this.props.currentQuestionType}
                    currentVariableMap={this.props.currentVariableMap}
                    isMobile={this.props.isMobile}
                    showAnswerResponse={this.props.showAnswerResponse}
                    answerCorrect={this.props.answerCorrect}
                    currentVectorVariableMap={this.props.currentVectorVariable}
                    answerType={this.props.answerType}
                    showSubmitLoader={this.props.showSubmitLoader}
                    currentAnswerType={this.props.answerType}
                    compact={this.props.compact}
                />
            } else if (this.props.answerType === 3) {
                answerDisplay = <AnswerTypeRPTextBox
                    onAnswerChoice={this.onAnswerTextbboxHandler}
                    currentVariableMap={this.props.currentVectorVariable}
                    currentVectorVariableMap={this.props.currentVectorVariable}
                    answer_formula={this.props.answer_formula}
                    showRPAnswer={this.props.showRPAnswer}
                    questionID={this.props.questionID}
                    answerFormat={this.props.answerDisplayStyle}
                    onSubmit={this.props.onSubmit}
                    onAnswerChoiceDetails={this.props.onAnswerChoiceDetails}
                    isMobile={this.props.isMobile}
                    showAnswerResponse={this.props.showAnswerResponse}
                    answerCorrect={this.props.answerCorrect}
                    showSubmitLoader={this.props.showSubmitLoader}
                    currentQuestionType={this.props.currentQuestionType}
                    compact={this.props.compact}
                    textValue={this.props.selectedAnswers}
                    selectedAnswers={this.props.selectedAnswers}
                    question_attempt={this.props.question_attempt}
                    alreadyPickedAnswer={this.props.alreadyPickedAnswer}
                />
            } else {
                answerDisplay = <SFVectorTypeAnswer
                    currentQuestionID={this.props.questionID}
                    questionText={this.props.questionText}
                    onAnswerChoice={this.onMQTAnswerChoice}
                    answerType={this.props.answerType}
                    variableMap={this.props.currentVectorVariable}
                    answers={this.props.displayAnswerArr}
                    selectedAnswer={this.props.selectedAnswers}
                    vectorSettings={this.props.currentVectorSettings}
                    showVectorAnswer={this.props.showVectorAnswer}
                    correctAnswerVectors={this.props.correctAnswerVectors}
                    vectorAnswerFormulas={this.props.vectorAnswerFormulas}
                    freeFormVectorOptions={this.props.freeFormVectorOptions}
                    numOfColumns={this.props.answerDisplayStyle}
                    showAnswerResponse={this.props.showAnswerResponse}
                    answerCorrect={this.props.answerCorrect}
                    count={this.props.count}
                    showSubmitLoader={this.props.showSubmitLoader}
                    compact={this.props.compact}
                    selectedAnswers={this.props.selectedAnswers}
                    question_attempt={this.props.question_attempt}
                    alreadyPickedAnswer={this.props.alreadyPickedAnswer}
                />
            }
        } else if (this.props.currentQuestionType === 4) { // reasoning chain question type
            answerDisplay = <AnswerTypeReasoningChain {...this.props} onReasoningChainFormatChange={this.props.onAnswerEntered} />

        } else if (this.props.answerType === 0) {
            // answer type is 0 show radio button
            answerDisplay = <SFMCRadioTypeAnswers
                displayAnswerArr={this.props.displayAnswerArr}
                onAnswerChoice={this.onAnswerChoice}
                selectedAnswers={this.props.selectedAnswers}
                numOfColumns={this.props.answerDisplayStyle}
                currentQuestionType={this.props.currentQuestionType}
                currentVariableMap={this.props.currentVariableMap}
                isMobile={this.props.isMobile}
                showAnswerResponse={this.props.showAnswerResponse}
                answerCorrect={this.props.answerCorrect}
                showSubmitLoader={this.props.showSubmitLoader}
                currentAnswerType={this.props.answerType}
                compact={this.props.compact}
            />
        } else if (this.props.answerType === 1) {
            // answer type is 1 show checkbox
            answerDisplay = <SFMCChecboxTypeAnswers
                displayAnswerArr={this.props.displayAnswerArr}
                selectedAnswerArray={this.props.selectedAnswers}
                onAnswerChoice={this.onAnswerChoice}
                numOfColumns={this.props.answerDisplayStyle}
                currentQuestionType={this.props.currentQuestionType}
                currentVariableMap={this.props.currentVariableMap}
                isMobile={this.props.isMobile}
                showAnswerResponse={this.props.showAnswerResponse}
                answerCorrect={this.props.answerCorrect}
                showSubmitLoader={this.props.showSubmitLoader}
                currentAnswerType={this.props.answerType}
                compact={this.props.compact}
            />
        } else if (this.props.answerType === 2) {
            answerDisplay = <SFTextboxTypeAnswer
                key={this.props.questionID}
                onAnswerChoice={this.onAnswerTextbboxHandler}
                isMobile={this.props.isMobile}
                compact={this.props.compact}
                textValue={this.props.selectedAnswers}
            />
        }
        else if (this.props.answerType === 3) {
            // answer type is 3 show RP Text Box
            answerDisplay = <AnswerTypeRPTextBox
                onAnswerChoice={this.onAnswerTextbboxHandler}
                currentVariableMap={this.props.currentVariableMap}
                answer_formula={this.props.answer_formula}
                showRPAnswer={this.props.showRPAnswer}
                questionID={this.props.questionID}
                answerFormat={this.props.answerDisplayStyle}
                onSubmit={this.props.onSubmit}
                onAnswerChoiceDetails={this.props.onAnswerChoiceDetails}
                isMobile={this.props.isMobile}
                showAnswerResponse={this.props.showAnswerResponse}
                answerCorrect={this.props.answerCorrect}
                showSubmitLoader={this.props.showSubmitLoader}
                currentQuestionType={this.props.currentQuestionType}
                compact={this.props.compact}
                selectedAnswers={this.props.selectedAnswers}
                question_attempt={this.props.question_attempt}
                alreadyPickedAnswer={this.props.alreadyPickedAnswer}
            />
        }

        console.debug("this.props.selectedAnswers------", this.props.selectedAnswers)

        /* console.debug("answerDisplay>>", this.props.questionID, this.props.answer_formula, this.props.answerType, this.props.answerDisplayStyle, answerDisplay) */

        return answerDisplay
    }

    refreshShoeList() {

        this.setState({ shouldRefreshRadioComp: !this.state.shouldRefreshRadioComp });
    }

    loadImages = () => {
        if (this.questionCardRef && this.questionCardRef.current) {
            const images = this.questionCardRef.current.querySelectorAll("img");
            this.setImages(images);
        }

        if (this.answerCardRef && this.answerCardRef.current) {
            const images = this.answerCardRef.current.querySelectorAll("img");
            this.setImages(images);
        }

    }

    setImages = (images) => {
        images.forEach(img => {

            const applyClass = () => {
                img.classList.remove("landscape", "portrait");

                if (img.naturalWidth >= img.naturalHeight) {
                    img.classList.add("landscape");
                } else {
                    img.classList.add("portrait");
                }
            };

            if (img.complete && img.naturalWidth) {
                applyClass();
            } else {
                img.addEventListener("load", applyClass, { once: true });
            }
        });
    }



    handleQuestionResize = (type) => {
        if (this.questionCardRef && this.questionCardRef.current) {
            let images = this.questionCardRef.current.querySelectorAll('img');

            if (images && images.length) {
                images.forEach(img => {
                    let newWidth = type === "plus" ? img.offsetWidth + 50 : img.offsetWidth - 50;
                    img.classList.remove('landscape', 'portrait');
                    img.style.setProperty('width', `${newWidth}px`, 'important');
                    img.style.setProperty('height', 'auto', 'important');
                    /* let figure = img.closest('figure');
                    if (figure) {
                        figure.style.setProperty('width', `${newWidth}px`, 'important');
                    } */
                    if (img.classList.contains("custom-image-align-right")) {
                        if (newWidth >= 700) {
                            img.style.setProperty('float', "none", "important")
                        } else {
                            img.style.setProperty('float', "right", "important")
                        }
                    }
                    if (img.classList.contains("custom-image-align-left")) {
                        if (newWidth >= 700) {
                            img.style.setProperty('float', "none", "important")
                        } else {
                            img.style.setProperty('float', "left", "important")
                        }
                    }
                });
                // setState removed to prevent componentDidUpdate -> loadImages -> setImages
                // from re-applying landscape/portrait classes which undo the resize
            }
        }
    }

    handleAnswerResize = (type) => {
        if (this.answerCardRef && this.answerCardRef.current) {
            let images = this.answerCardRef.current.querySelectorAll('img');

            if (images && images.length) {
                images.forEach(img => {
                    let newWidth = type === "plus" ? img.offsetWidth + 50 : img.offsetWidth - 50;
                    img.classList.remove('landscape', 'portrait');
                    img.style.setProperty('width', `${newWidth}px`, 'important');
                    img.style.setProperty('height', 'auto', 'important');
                    /* let figure = img.closest('figure');
                    if (figure) {
                        figure.style.setProperty('width', `${newWidth}px`, 'important');
                    } */
                    if (img.classList.contains("custom-image-align-right")) {
                        if (newWidth >= 700) {
                            img.style.setProperty('float', "none", "important")
                        } else {
                            img.style.setProperty('float', "right", "important")
                        }
                    }
                    if (img.classList.contains("custom-image-align-left")) {
                        if (newWidth >= 700) {
                            img.style.setProperty('float', "none", "important")
                        } else {
                            img.style.setProperty('float', "left", "important")
                        }
                    }
                });
                // setState removed to prevent componentDidUpdate -> loadImages -> setImages
                // from re-applying landscape/portrait classes which undo the resize
            }
        }
    }

    render() {
        let answerResponse = "";
        let classNames = "";

        var QuestionContainterAnswerResStyle = { backgroundColor: "white" };
        let answersContentDisplay = null
        console.log("forceUpdateHandler = ", this.props.forceUpdateHandler);
        if (this.props.forceUpdateHandler === true) {

            console.log("forceUpdateHandler");
            answersContentDisplay = this.answersDetailsDisplay();
        } else {
            console.log("Else part forceUpdateHandler");
            answersContentDisplay = this.answersDetailsDisplay();
        }

        if (this.props.isCurrentQuestionNonGraded) {
            //No feedback if it is a non-graded question. 
        }
        else if (!this.props.answerCorrect) {
            answerResponse = "Incorrect Answer";
            classNames = "QuestionWithImageTopBar redBackground";
            QuestionContainterAnswerResStyle = { backgroundColor: "rgba(220, 53, 69, 0.25)" };
        }
        else {
            answerResponse = "Correct Answer";
            classNames = "QuestionWithImageTopBar greenBackground";
            QuestionContainterAnswerResStyle = { backgroundColor: "rgba(75, 255, 75, 0.42)" };

        }

        const checkIfTextContainsAnImage = (text) => {
            let vectorBelowQuestionText = this.props.vectorBelowQuestionText;
            if (vectorBelowQuestionText) {
                text += vectorBelowQuestionText;
            }
            if (text === undefined || text === null || text === "") return false;
            return text.includes("<img") && text.includes("</img>")
        }

        /*  if (this.props.compact) {
             return <div >
                 <SFCompactQA 
                     questionText={this.props.questionText}
                     questionNo={this.props.uniqueID}
                     answersContentDisplay={answersContentDisplay}
                     currentVariableMap={this.props.currentVariableMap}
                     handleBookmarkClick={this.props.handleBookmarkClick}
                 />
             </div>
         } */

        return <Card sx={{ boxShadow: 0 }} className='sf-qa-card'
            id={this.props.compact ? undefined : 'quiz-main-content'}
            tabIndex={this.props.compact ? undefined : -1}
            style={{
                height: this.props.compact ? '' : '100%',
                width: '100%',
                position: 'relative',
                outline: 'none'
                // border:'1px solid #aaaaaa',
            }} >

            <CardContent style={{
                height: this.props.compact ? '' : '100%',
                width: '100%',
                position: 'relative'
            }}>
                <div className=' w-100 position-relative' style={{
                    height: this.props.compact ? '' : '100%',
                    display: 'flex',
                    flexDirection: window.innerWidth > 900 && !this.props.compact ? 'row' : 'column',
                    justifyContent: 'flex-start',
                    alignItems: 'flex-start',
                    gap: this.props.hideQuestion ? 0 : '1.5rem'

                }}>
                    {/* QUESTION UI */}
                    <div className='position-relative '
                        id={this.props.questionContainerId || `question-no-${this.props.uniqueID}`}
                        tabIndex={this.props.questionContainerId ? 0 : undefined}
                        role={this.props.questionContainerId ? 'region' : undefined}
                        aria-label={this.props.questionContainerId ? `Question ${this.props.questionNo}. ${getCleanQuestionText(this.props.questionText)}` : undefined}
                        style={{
                            // width: window.innerWidth > 900 ? '50%' : '100%',
                            backgroundColor: "#EFF1F2",
                            border: "1px solid #A7B1B7",
                            boxShadow: "4px 4px 15px 0px rgba(0, 0, 0, 0.25)",
                            borderRadius: "8px",
                            // padding: "8px 16px",
                            // height: '100%',
                            overflow: 'hidden',
                            width: this.props.hideQuestion ? '0px' : (window.innerWidth > 900 && !this.props.compact ? '50%' : '100%'),
                            height: this.props.hideQuestion ? '0px' : (this.props.currentQuestionType === 4 ? '50%' : '100%'),
                            padding: this.props.hideQuestion ? 0 : '0.5rem',
                            transform: this.props.hideQuestion ? "scale(0)" : "scale(1)",
                            transition: this.props.hideQuestion ? 'transform 0.6s ease, width 0.6s ease, height 0.6s ease 0.6s' :
                                'height 0s ease, transform 0.6s ease , width 0.6s ease',
                            borderWidth: this.props.hideQuestion ? 0 : 1,
                            transformOrigin: 'bottom left',
                            // display: this.props.hideQuestion ? 'none': 'block',
                        }}>
                        <div className='sf-question-card w-100 position-relative' style={{
                            overflowY: this.props.compact ? 'hidden' : 'auto',
                            overflowX:'hidden',
                            opacity: this.props.hideQuestion ? 0 : 100,
                            height: this.props.compact ? 'fit-content' : '100%',
                        }} 
                        ref={this.questionCardRef}
                        >
                            <div className='d-flex justify-content-between align-items-center sf-question-header-position' style={{ backgroundColor: "#EFF1F2", zIndex:"1" }}>
                                <div className='d-flex justify-content-start'>
                                    <Typography
                                        variant='h6'
                                        component={this.props.questionHeadingId ? 'h2' : undefined}
                                        id={this.props.questionHeadingId}
                                        fontWeight={'500'}
                                        className='mb-1'
                                    >
                                        Question: {this.props.compact ? this.props.questionNo : null}
                                        {/* ({this.props.currentQuestionType}) */}
                                    </Typography>
                                    <div className='sf-image-resize-btn-container' style={{
                                        display: checkIfTextContainsAnImage(this.props.questionText) ? 'flex' : 'none'
                                    }}>
                                        <Tooltip placement="top" arrow title="Magnify all images within the question">
                                            <button className="sf-image-resize-btn" onClick={() => {
                                                this.handleQuestionResize("plus")
                                             }}>
                                                <HiOutlineZoomIn fontSize={25} />
                                            </button>
                                        </Tooltip>
                                        <Tooltip placement="top" arrow title="Shrink all images within the question">
                                            <button
                                                disabled={this.state.questionImageWidth === 200}
                                                style={{
                                                    color: this.state.questionImageWidth === 200 ? 'gray' : '#BA0C2F'
                                                }}
                                                className="sf-image-resize-btn" onClick={() => {
                                                    this.handleQuestionResize("minus")
                                                }}>
                                                <HiOutlineZoomOut fontSize={25} />
                                            </button>
                                        </Tooltip>
                                    </div>
                                </div>
                                {!this.props.compact ?
                                    <Tooltip placement="top" arrow title="Hide Question">
                                        <IconButton aria-label="Hide Question" color="primary" onClick={this.props.handleHideQuestion}>
                                            {/* <IoIosCloseCircleOutline color='black' fontSize={26} /> */}
                                            <FaMinus fontSize={24} />
                                            {/* <MdMinimize color='black' fontSize={26} /> */}
                                        </IconButton>
                                    </Tooltip>
                                    : null}
                            </div>
                            <div
                                className='text-align-left pl-2 px-2'
                                id={this.props.questionContentId}
                                tabIndex={this.props.questionContentId ? 0 : undefined}
                                role={this.props.questionContentId ? 'region' : undefined}
                                aria-label={this.props.questionContentId ? `Question. ${getCleanQuestionText(this.props.questionText)}` : undefined}
                            >
                                {this.props.currentQuestionType === 3 ?
                                    <VectorQuestion
                                        questionText={this.props.questionText}
                                        variableMap={this.props.currentVectorVariable}
                                        vectorSettings={this.props.currentVectorSettings}
                                        vectorBelowQuestionText={this.props.vectorBelowQuestionText}
                                        answers={this.props.displayAnswerArr}
                                        answerType={this.props.answerType}
                                        addSingleQuestionAnswerState={this.props.addSingleQuestionAnswerState}
                                        freeFormVectorOptions={this.props.freeFormVectorOptions}
                                        currentQuestionID={this.props.questionID}
                                    />
                                    :
                                    /* <ResizableImageContent questionText={this.props.questionText} currentVariableMap={this.props.urrentVariableMap} /> */
                                    <MathJax math={MathParserUtil.setVariablesToText(this.props.questionText, this.props.currentVariableMap, { formatValues: true })} />

                                }

                                {this.props.questionText !== null ? createVideoLinkIframe(this.props.questionText) : ''}
                            </div>
                        </div>
                    </div>

                    {/* ANSWER UI */}
                    <div className='position-relative' style={{
                        width: this.props.hideQuestion ? '100%' : (window.innerWidth > 900 && !this.props.compact ? '50%' : '100%'),
                        transition: 'width 0.6s ease',
                        // height: 'calc(100% - 50px)',
                        height: this.props.compact ? 'fit-content' : 'calc(100% - 50px)'
                    }}>
                        <div className='d-flex justify-content-between align-items-center'>
                            <Typography 
                                variant='h6' 
                                fontWeight={'500'} 
                                className='d-flex align-items-center mb-1'
                                tabIndex={0}
                                aria-label={`Answer. ${this.props.showWelcomeBackMsg ? "Welcome back! We're picking back up where you left off..." : ""}`}
                            >
                                Answer: {this.props.showWelcomeBackMsg ? 
                                    <small className='ml-1'>(Welcome back! We're picking back up where you left off...)</small>
                                : null}
                                <div className='sf-image-resize-btn-container'
                                    style={{
                                        display: this.answerContainsAnImage ? 'flex' : 'none'
                                    }}
                                >
                                    <Tooltip placement="top" arrow title="Magnify all images in all answers">
                                        <button className="sf-image-resize-btn" onClick={() => {
                                            this.handleAnswerResize("plus")
                                        }}>
                                            <HiOutlineZoomIn fontSize={25} />
                                        </button>
                                    </Tooltip>
                                    <Tooltip placement="top" arrow title="Shrink all images within all answers">
                                        <button
                                            // disabled={this.state.answerImageWidth === 200}
                                            style={{
                                                // color: this.state.answerImageWidth === 200 ? 'gray' : '#BA0C2F'
                                            }}
                                            className="sf-image-resize-btn" onClick={() => {
                                                this.handleAnswerResize("minus")
                                            }}>
                                            <HiOutlineZoomOut fontSize={25} />
                                        </button>
                                    </Tooltip>
                                </div>
                                {/* ({this.props.answerType})
                            ({this.props.answerDisplayStyle}) */}
                                {/* {!this.props.isCurrentQuestionNonGraded && this.props.showAnswerResponse ?
                                <div className='answer-feedback mx-2'>
                                    {this.props.answerCorrect ?
                                        <div className='d-flex justify-content-start align-items-center' style={{ gap: "4px", color: '#80c75b' }}>
                                            <FaRegCircleCheck fontSize={20} />
                                            <div style={{ fontWeight: 'bolder', fontSize: '18px', letterSpacing: '0.5px' }}>Correct</div>
                                        </div>
                                        :
                                        <div className='d-flex justify-content-start align-items-center' style={{ gap: "4px", color: '#BA0C2F' }}>
                                            <CgCloseO fontSize={20} />
                                            <div style={{ fontWeight: 'bolder', fontSize: '18px', letterSpacing: '0.5px' }}>Incorrect</div>
                                        </div>
                                    }
                                </div>
                                : null} */}
                            </Typography>
                            {!this.props.compact ?
                                <Tooltip placement="top" arrow title={this.props.hideNavAndCat ? "Minimize Answer" : "Expand Answer"}>
                                    <IconButton color="primary" onClick={this.props.handleHideNavAndCat}>
                                        {this.props.hideNavAndCat ? <CgMinimize fontSize={26} /> : <RxEnterFullScreen fontSize={26} />}
                                    </IconButton>
                                </Tooltip>
                                : null}
                        </div>

                        <div className='sf-answer-card w-100 h-100' ref={this.answerCardRef}>
                            {answersContentDisplay}
                        </div>
                    </div>
                </div>
            </CardContent>



        </Card>
    };

    // QuestionWithImage.propTypes = {
    //     title: PropTypes.string.isRequired,
    //     questionImage: PropTypes.any,
    //     imageCaption:PropTypes.string.isRequired,
    //     questionText:PropTypes.string.isRequired,
    //     onAnswerEntered:PropTypes.func.isRequired,
    // }

}

export default SFQuestionAndAnswer

